import { advantages } from 'legacy/data/advantages';
import Advantages from 'components/Advantages/Advantages';

/**
 * This component is a placeholder for the Advantages component to be able to link it via Contentful.
 */
export function AdvantagesLink() {
  return <Advantages {...advantages} />;
}
